import { useCallback, useEffect } from "react"

import useWorldStore from "../store/worldStore"
import { getFloatingWindowZIndex } from "../lib/floatingWindowOrder"

export default function useFloatingWindowLayer(windowId) {
  const windowOrder = useWorldStore((state) => state.floatingWindowOrder || [])
  const registerFloatingWindow = useWorldStore(
    (state) => state.registerFloatingWindow
  )
  const unregisterFloatingWindow = useWorldStore(
    (state) => state.unregisterFloatingWindow
  )
  const focusFloatingWindow = useWorldStore(
    (state) => state.focusFloatingWindow
  )

  useEffect(() => {
    if (!windowId) return undefined

    registerFloatingWindow(windowId)
    return () => unregisterFloatingWindow(windowId)
  }, [registerFloatingWindow, unregisterFloatingWindow, windowId])

  const focusWindow = useCallback(() => {
    if (!windowId) return
    focusFloatingWindow(windowId)
  }, [focusFloatingWindow, windowId])

  return {
    zIndex: getFloatingWindowZIndex(windowOrder, windowId),
    focusWindow,
    focusProps: {
      onPointerDownCapture: focusWindow,
    },
  }
}
